import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '@vromo/mobx-react';
import orderBy from 'lodash/orderBy';

import { css } from 'emotion';

import { Policy, Site } from '@vromo/models';

import Container from '@vromo/ui/components/Container';
import Button from '@vromo/ui/components/Button';
import Table from '@vromo/ui/components/Table';
import Title from '@vromo/ui/components/Title';
import Debug from '@vromo/ui/components/Debug';

import NewSite from './EditSiteModal';

import { Contact } from '@vromo/models';
import { RootStore } from '../stores/RootStore';
import { update } from 'serializr';
import { head, sortBy } from 'lodash';
import useComputed from '@vromo/hooks/useComputed';
import { SiteRow } from './SiteRow';
import { qaLabelTestSites } from './../../../../common-qa-labels/sites'

export const STARTER_TEMPLATE = 'Starter 4 Task Model';

export default observer(function Sites() {
    const {
        authStore: { graph, role },
        siteStore,
        blueprintStore,
        policyStore
    } = useStore<RootStore>('rootStore');

    const [editing, setEditing] = useState(false);
    const [editedSite, setEditedSite] = useState(new Site());

    useEffect(() => {
        graph.root
            .graph()
            .roles(role.id)
            .blueprints()
            .get()
            .then((blueprints) => {
                update(blueprintStore.blueprints, blueprints);
            });
    }, []);

    const sortedPolicyOptions = useComputed(() =>
        sortBy(
            policyStore.policies.map((g) => ({ label: g.name!, value: g.id! })),
            ['label']
        )
    );

    function setNewSite(): void {
        const newSite = new Site();
        newSite.contact = new Contact();
        if (sortedPolicyOptions.length) {
            newSite.policy = new Policy(head(sortedPolicyOptions)!.value);
        }
        const defaultBlueprint = blueprintStore.blueprints.find(({name}) => name === STARTER_TEMPLATE);
        if(!!defaultBlueprint) {
            newSite.blueprint = {id: defaultBlueprint.id};
        }
        setEditedSite(newSite);
    }

    return (
        <>
            <div
                className={css`
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0px 16px;
                `}>
                <Title>Sites</Title>
                <Button
                    data-testid= {qaLabelTestSites.addNewSiteButton}
                    onClick={() => {
                        setEditing(true);
                        setNewSite();
                    }}>
                    Add New Site
                </Button>
            </div>
            <Container>
                <div style={{ width: '100%', overflow: 'auto', marginTop: '15px' }}>
                    <Table>
                        <thead>
                            <tr>
                                <th />
                                <th>Name</th>
                                {/* <th>ID</th> */}
                                <th>Address</th>
                                <th>Group</th>
                                <th>Auto Dispatcher</th>
                                <th>Campaign</th>
                                <Debug>
                                    <th>Blueprint</th>
                                </Debug>
                            </tr>
                        </thead>
                        <tbody data-testid={qaLabelTestSites.tableBody}>
                            {orderBy(siteStore.sites.items, (it) => it.contact?.name, ['asc']).map(
                                (site: Site) => (
                                    <SiteRow
                                        key={site.id}
                                        onClick={() => {
                                            setEditing(true);
                                            setEditedSite(site);
                                        }}
                                        site={site}
                                    />
                                )
                            )}
                        </tbody>
                    </Table>
                </div>
                <NewSite
                    open={editing}
                    close={() => {
                        setEditing(false);
                    }}
                    site={editedSite}
                    isNew={editedSite.id === undefined}
                    sortedPolicyOptions={sortedPolicyOptions}
                />
            </Container>
        </>
    );
});
